import { render, staticRenderFns } from "./iPageTitle.vue?vue&type=template&id=37bd430c"
import script from "./iPageTitle.vue?vue&type=script&lang=js"
export * from "./iPageTitle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports